export function extractContentFromHtml(htmlString: string): string {
  const span = document.createElement('span');
  span.innerHTML = htmlString;
  return span.textContent || span.innerText;
}
